
import { useState } from 'react';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import { Modal, ModalBody, ModalContent, ModalTrigger } from '@/common-utils/components/ui/modal';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import actionsPosTerminals from '../../../api/actionsPosTerminals';
import { DateTime } from 'luxon';
import useCheckConnectionPoints from '../../../hooks/useCheckConnectionPoints';
import PropTypes from 'prop-types';
import { useToast } from '@/common-utils/hooks/use-toast';
import { nsTerminal } from '@/app/i18n/namespaces';

/**
 * @param {JSX.Element} trigger element that triggers modal opening
 * @returns {JSX.Element} ModalAllowTemporarily Component
 */
function ModalAllowTemporarily({ trigger, isOpen, setIsOpen, subscriptionId, setLaunchRefetch }) {

    // Constants
    const BLACKLIST_START_DATE = DateTime.now().plus({ days: 1 });

    // Toast
    const { toast } = useToast();

    // State
    const [bodyContent, setBodyContent] = useState(<></>);

    // API Calls
    // Queries
    const getConnectionPointsResponse = actionsPosTerminals.getConnectionPoints(subscriptionId);

    // Mutations
    const onSuccess = () => {
        setLaunchRefetch(true);
        setIsOpen(false);
        toast({
            description: <Entity entity={'modal.allow_temporarily.success'} namespace={nsTerminal} />,
            variant: 'success'
        });
    };
    const onError = () => {
        setIsOpen(false);
        toast({
            description: <Entity entity={'modal.allow_temporarily.error'} namespace={nsTerminal} />,
            variant: 'danger'
        });
    };
    const submitAllowTemporarily = actionsPosTerminals.blacklistPosTerminal(onSuccess, onError);

    // Hooks
    useCheckConnectionPoints(getConnectionPointsResponse, setBodyContent, 'modal.allow_temporarily');

    // Renders
    const content =
        <ModalContent className={cn('max-w-lg')}>
            <HeaderTitle title={'modal.allow_temporarily.title'} namespace={nsTerminal} />
            <ModalBody>
                {bodyContent}
            </ModalBody>
            <FooterForm
                onSubmit={() => submitAllowTemporarily.mutate({
                    subscriptionId,
                    blacklistStartDate: BLACKLIST_START_DATE
                })}
                isSubmitting={submitAllowTemporarily.isLoading}
                isSubmitDisabled={getConnectionPointsResponse.isLoading}
            />
        </ModalContent>;

    if (trigger) {
        return (
            <Modal>
                <ModalTrigger>{trigger}</ModalTrigger>
                {content}
            </Modal>
        );
    }

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            {content}
        </Modal>
    );
}

ModalAllowTemporarily.propTypes = {
    trigger: PropTypes.element,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    subscriptionId: PropTypes.string,
    setLaunchRefetch: PropTypes.func
};

export default ModalAllowTemporarily;